var _defs, _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.01 15.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #010101;\n        stroke-miterlimit: 10;\n        stroke-width: .47px;\n      }\n\n      .cls-2 {\n        fill: #010101;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 1.44,
    width: 17.01,
    height: 13.77,
    rx: 0.69,
    ry: 0.69
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m16.21,13.97c-2.39-.35-4.93-.26-7.57.65V1.65C11.29-.11,13.81-.11,16.21,1v12.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m.89,13.97c2.39-.35,4.93-.26,7.57.65V1.65C5.81-.11,3.29-.11.89,1v12.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/Book.5cff2588f7a869b1f9a71f6c8501de2a.svg";
export { ForwardRef as ReactComponent };